"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const client_library_1 = require("@seneca/client-library");
const forms_service_consts_1 = require("@seneca/forms-service-consts");
const FormSubmissionNotFound_1 = require("./errors/FormSubmissionNotFound");
class FormsServiceClient extends client_library_1.Client {
    constructor(fetch, options) {
        super(fetch, options);
    }
    async submitSchoolLeadsForm(data) {
        const url = `${this.url}/api/forms/school-leads`;
        const options = { method: 'POST', body: JSON.stringify(data) };
        const expectedResponses = [201, 422];
        return await this.requestMaker.makeRequest(url, options, expectedResponses);
    }
    async submitSchoolRenewalForm(data) {
        const url = `${this.url}/api/forms/school-renewal`;
        const options = { method: 'POST', body: JSON.stringify(data) };
        const expectedResponses = [201, 422];
        return await this.requestMaker.makeRequest(url, options, expectedResponses);
    }
    /**
     * @throws {FormSubmissionNotFound} if the response is 404 or the response body is undefined
     */
    async fetchSchoolLeadsForm(submissionId) {
        return this.fetchForm(forms_service_consts_1.SchoolLeadsFormName, submissionId);
    }
    /**
     * @throws {FormSubmissionNotFound} if the response is 404 or the response body is undefined
     */
    async fetchForm(formName, submissionId) {
        const url = `${this.url}/api/forms/${formName}/${submissionId}`;
        const options = { method: 'GET' };
        const expectedResponses = [200, 404];
        const response = await this.requestMaker.makeRequest(url, options, expectedResponses);
        if (response.status === 404 || !response.json) {
            throw new FormSubmissionNotFound_1.FormSubmissionNotFound(submissionId);
        }
        return response.json;
    }
}
exports.default = FormsServiceClient;
//# sourceMappingURL=FormsServiceClient.js.map